import ArticlePage from "@/pages/article/ArticlePage";

export default function TopAccessoriesBags() {
  return <ArticlePage slug="top-accessories-bags-vigorbuy" />;
}